import React, { memo, useCallback, useMemo } from 'react';
import { useParams } from 'react-router';

import { Dropdown } from 'components';

const LanguageDropdown = ({ options }) => {
  const params = useParams();
  const { lang } = params ?? {};

  const currentSelected = useMemo(
    () =>
      options.find(
        ({ countryFlag }) => countryFlag.toUpperCase() === lang.toUpperCase()
      )?.name,
    [lang, options]
  );

  const goToLink = useCallback(
    (countryFlag, toggleDropdownOptions) => {
      typeof toggleDropdownOptions === 'function' && toggleDropdownOptions();
      const { bu: businessUnit, section } = params;
      if (!section) {
        return (window.location.href = `${
          window.location.origin
        }/${businessUnit}/${countryFlag.toUpperCase()}`);
      }
      window.location.href = `${
        window.location.origin
      }/${businessUnit}/${section}/${countryFlag.toUpperCase()}`;
    },
    [params]
  );

  const onClickFactory = useCallback(
    (option, toggleDropdownOptions) => {
      const { countryFlag } = option;

      return () => {
        if (countryFlag?.toUpperCase() === lang?.toUpperCase()) {
          typeof toggleDropdownOptions === 'function' &&
            toggleDropdownOptions();
          return;
        }
        goToLink(countryFlag, toggleDropdownOptions);
      };
    },
    [goToLink, lang]
  );

  return (
    <Dropdown
      options={options}
      onClickFactory={onClickFactory}
      selectedName={currentSelected}
    />
  );
};

export default memo(LanguageDropdown);
